import React, { useState, useEffect } from 'react'
import {
  useShowController,
  useTranslate,
  TextField,
  Datagrid,
  FunctionField,
  useNotify,
  useRecordContext,
  DateField,
  DatagridBody,
} from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import EditIcon from '@mui/icons-material/Edit'
import PersonIcon from '@mui/icons-material/Person'
import { iconAccordingProduct } from 'src/components/pages/sales/reservation/helper/IconAccordingProduct'
import { Backdrop, Button, Checkbox, CircularProgress, Grid, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { isStatus } from 'src/components/pages/sales/reservation/helper/isStatus'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { FormattedTextFieldWithStatus } from 'src/components/pages/sales/reservation/helper/FormattedTextFieldWithStatus'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { useRefresh } from 'react-admin'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { EditButton } from 'src/components/uiElements/buttons/EditButton'
import { ReAssignModal } from 'src/components/pages/sales/reservation/logic/modals/ReAssignModal'
import { useQuery } from 'react-query'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { itemServices } from 'src/services/reservation/item/item.service'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import {
  PERMISSION_AUTO_BILL,
  PERMISSION_CHANGE,
  PERMISSION_CREATE,
  PERMISSION_IS_BILLABLE,
  PERMISSION_LIST,
  PERMISSION_SHOW,
} from 'src/helper/Permission'
import { useReservationInfo } from '../../context/ReservationContext'

import { ReAssignModalSeller } from '../modals/ReAssignModalSeller'
import { ReAssignModalBase } from '../modals/ReAssignModalBase'
import { styled } from '@mui/material/styles'
import { PAID } from './state'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'


const CustomBody = (props) => {
  const record = useRecordContext()
  const items = record.items
  const [currencies, setCurrencies] = useState([])

  useEffect(()=>{
    if(items){
      let auxCurrencies = {}
      for(let item of items){
        const amount = item?.pricing_relation?.[0]?.liquidation_wholesaler?.liquidation?.rules?.resultVars?.billable_amount ?? 0
        const currency = item?.pricing_relation?.[0]?.currency ?? ''
        if(auxCurrencies[currency]){
          auxCurrencies[currency] = auxCurrencies[currency] + amount
        } else {
          auxCurrencies[currency] = amount
        }
      }
      setCurrencies(Object.entries(auxCurrencies))
    }
  },[items])
  return(
    <>
      <DatagridBody {...props} />

      {currencies.map(curr=>(
        <TableRow>

          <TableCell colSpan={3 + (hasPermissionFunction('sales', PERMISSION_LIST) && 1) + (hasPermissionFunction(DUE_DATE_RANGE_PERMISSION_ENTITY, PERMISSION_SHOW) && 1)} />
          
          <TableCell  style={{width:'100%', justifyContent:'flex-end', display:'flex', alignItems:'center'}}>
            <Typography
              style={{ 
                fontSize: "0.9rem",
                fontFamily: "'Roboto Condensed',sans-serif",
                fontWeight: 'bold',
                color:'rgba(0, 0, 0, 0.87)'
              }}
            >
              {`Total ${curr[0]}`}
            </Typography>
          </TableCell>
          
          <TableCell
          >
            <Typography
            style={{ 
                fontSize: "0.9rem",
                fontFamily: "'Roboto Condensed',sans-serif",
                fontWeight: 'bold',
                color:'rgba(0, 0, 0, 0.87)'
              }}
              variant="body2"
            >
              {`$ ${numberFormatterWithDecimalAndThousand(curr[1])}`}
           </Typography>
          </TableCell>

        </TableRow>
      ))
        
      }
    </>
  )
}


const BillingStatus = (label) => {
  const record = useRecordContext()
  const translate = useTranslate()
  const { reservationInfo, setReservationInfo } = useReservationInfo()
  const [loadingBillingStatus, setLoadingBillingStatus] = useState(true)
  const [billing, setBilling] = useState({})

  useEffect(() => {
    if (record && record?.hash_) {
      getBillingStatus(record?.hash_)
    }
  }, [record])

  const getBillingStatus = async (hash) => {
    try {
      if (hash) {
        const billing = await itemServices.get_billing_status(hash)
        setBilling(billing)
        setReservationInfo((prevInfo) => {
          let newBillingInfo = { ...prevInfo?.billing_info }
          newBillingInfo[record?.hash_] = billing
          return {
            ...prevInfo,
            billing_info: newBillingInfo,
          }
        })
        return
      }
    } catch (error) {
    } finally {
      setLoadingBillingStatus(false)
    }
  }

  const getStausLabel = (billing) => {
    if (!billing?.billable_status) {
      return '-'
    }
    if (billing?.billable_status) {
      return translate(`ra.status.${billing?.billable_status}`)
    }
  }

  return (
    <>
      {loadingBillingStatus ? (
        <CircularProgress size={'10px'} />
      ) : (
        <FunctionField
          label={label}
          render={() => getStausLabel(billing)}
          style={{ ...isStatus(label, billing?.billable_status, true) }}
        />
      )}
    </>
  )
}


const getBackgroundColor = (status) => {
  try {
    if (status === 'warning') {
      return '#FF9800'
    }
    if (status === 'expired') {
      return '#f44336'
    }
    if (status === 'paid') {
      return '#22ee65'
    }
      return 'transparent'
  } catch (error) {
    return 'transparent'
  }
}



const StyledDateField = styled(DateField)(({ status }) => ({
  backgroundColor: getBackgroundColor(status),
  padding: '4px 8px',
  borderRadius: '4px',
  color: status !== 'normal' ? '#fff' : 'inherit',
}))

export const DueDate = ({ label }) => {
  const record = useRecordContext()
  // Calcula la diferencia de días entre la fecha actual y la fecha de vencimiento
  const dueDate = new Date(record?.due_date_final + 'T00:00:00')
  dueDate.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  
  const diffTime = dueDate.getTime() - today.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
 
  let status = 'normal'
  if (diffDays === 0) {
    status = 'warning' // Vence hoy
  } else if (diffDays < 0) {
    status = 'expired' // Fecha ya vencida
  }

  if (record?.payment_status == PAID) {
    status = 'paid'
  }

  return <StyledDateField label={label} source='due_date_final' status={status} />
}

export const GeneralSection = () => {
  const translate = useTranslate()
  const {
    isFetching, // boolean that is true while the record is being fetched, and false once the record is fetched
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowController()

  const refresh = useRefresh()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const { setCardLoading } = useCardLoading()
  const [businessUnitUpdateLoading, setBusinessUnitUpdateLoading] = useState(false)
  const [sellerUpdateLoading, setSellerUpdateLoading] = useState(false)
  const [openSellerModal, setOpenSellerModal] = useState(false)
  const [openClientModal, setOpenClientModal] = useState(false)
  const [productsBillable, setProductsBillable] = useState()
  const [productsAutoBill, setProductsAutoBill] = useState()
  const [loadingItems, setLoadingItems] = useState(true)
  const [loadingOpenStatus, setLoadingOpenStatus] = useState(false)
  const [confirmOpenStatus, setConfirmOpenStatus] = useState(false)
  const [openStatusDialog, setOpenStatusDialog] = useState(false)
  const [isBillingLoading, setIsBillingLoading] = useState(false)
  const [autobillLoading, setAutobillLoading] = useState(false)
  const [openBaseModal, setOpenBaseModal] = useState(false)
  const [baseUpdateLoading, setBaseUpdateLoading] = useState(false)
  const [isBaseEditBlocked, setIsBaseEditBlocked] = useState(false)
  const [loadingBaseEditBlocked, setLoadingBaseEditBlocked] = useState(false)
  //service to modals
 
  const [modal, setModal] = useState({
    avoid: ['updated_at', 'created_at', 'id', 'is_active', 'is_agency'],
  })

  useEffect(() => {
    if (record) {
      if (record.items) {
        /* if (!productsBillable && record.items.every((elem) => elem.is_billable)) { */
          const productsBillableAux = {}
          record.items.forEach((elem) => (productsBillableAux[elem.id] = elem.is_billable))
          setProductsBillable(productsBillableAux)
        /* } */

        /* if (!productsAutoBill && record.items.every((elem) => elem.auto_bill)) { */
          const productsAutoBillAux = {}
          record.items.forEach((elem) => (productsAutoBillAux[elem.id] = elem.auto_bill))
          setProductsAutoBill(productsAutoBillAux)
        /* } */
      }
    }
  }, [record])

  const isItemLoading = (record) => {
    try {
       if (record) {
        if (record.items && record.items.every((elem) => Object.keys(elem)?.length > 3)) { // cuando esta cargando solo tiene 1 keys
          setLoadingItems(false)
        } 
      }   
    } catch (error) {
      setLoadingItems(false)
    }
  }

  useEffect(() => {
   isItemLoading(record)
  }, [record])

  useEffect(() => {
    if (record?.id && hasPermissionFunction('reservation', 'show_base')) {
      if (hasPermissionFunction('pricing', 'edit_billed')) {
        setIsBaseEditBlocked(false)
        return
      }
      setLoadingBaseEditBlocked(true)
      reservationServices.baseEditBlocked(record.id).then((blocked) => {
        setIsBaseEditBlocked(blocked ?? true)
      }).catch(() => {
        setIsBaseEditBlocked(true)
      }).finally(() => {
        setLoadingBaseEditBlocked(false)
      })
    }
  }, [record?.id])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(()=>{
    if(confirmOpenStatus){
      changeStatusToOpen()
    }
  },[confirmOpenStatus])

  const changeStatusToOpen = () =>{
    setLoadingOpenStatus(true)
    reservationServices.update_status('OPEN', record.id).finally(()=>{
      setLoadingOpenStatus(false)
    }).then(()=>{
      setOpenStatusDialog(false)
      notify('ra.message.change_status',{ messageArgs:{status:translate('ra.status.OPEN')}, type:'success'})
    }).catch(()=>{
      notify('ra.message.change_status_error',{type:'error'})
    })
  }

  const CustomHeader = ({ children }) => (
    <TableHead>
      <TableRow>
        {React.Children.map(children, (child) =>
          React.isValidElement(child) ? (
            <TableCell key={child.props.source} style={{ textAlign: child.props.textAlign || 'left' }}>
              <span>{child.props.label}</span>
            </TableCell>
          ) : null
        )}
      </TableRow>
    </TableHead>
  )


  const onSubmitReAssignClient = async (data, cardId) => {
    setBusinessUnitUpdateLoading(true)
    try {
      const response = await reservationServices.updateById(data.id, data)
      if (response) {
        notify('ra.notification.updated_success_business_unit', {
          type: 'success',
          messageArgs: { client: response?.business_unit_relation?.long_name },
        })
        return
      }
      notify('ra.notification.updated_error_business_unit', {
        type: 'error',
      })
    } catch (error) {
      notify('ra.notification.updated_error_business_unit', {
        type: 'error',
      })
    } finally {
      setBusinessUnitUpdateLoading(false)
      setModal((prevModal) => ({
        ...prevModal,
        open: false,
      }))
      setOpenClientModal(false)
      setCardLoading(cardId, true)
      customAwait([refresh])
    }
  }

  const onSubmitReAssignSeller = async (data, cardId) => {
    setSellerUpdateLoading(true)
    try {
      let change_business_unit = {
        ...data,
        user_id: data?.choice?.id_reservation_user,
      }
      const response = await reservationServices.updateById(data.id, change_business_unit)
      if (response) {
        notify('ra.notification.updated_success_seller', {
          type: 'success',
        })
        return
      }
      notify('ra.notification.updated_error_seller', {
        type: 'error',
      })
    } catch (error) {
      notify('ra.notification.updated_error_seller', {
        type: 'error',
      })
    } finally {
      setSellerUpdateLoading(false)
      setModal((prevModal) => ({
        ...prevModal,
        open: false,
      }))
      setOpenSellerModal(false)
      setCardLoading(cardId, true)
      customAwait([refresh])
    }
  }

  const onSubmitReAssignBase = async (baseId, cardId) => {
    setBaseUpdateLoading(true)
    try {
      const response = await reservationServices.editReservationBase(record.id, baseId)
      if (response) {
        notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.field.base_to_billing') },
        })
        return
      }
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.field.base_to_billing') },
      })
    } catch (error) {
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.field.base_to_billing') },
      })
    } finally {
      setBaseUpdateLoading(false)
      setOpenBaseModal(false)
      setCardLoading(cardId, true)
      customAwait([refresh])
    }
  }

  const getBillableAmount = (record) => {
    const billable_amount =
      record?.pricing_relation?.[0]?.liquidation_wholesaler?.liquidation?.rules?.resultVars?.billable_amount

    if (billable_amount != null) {
      // Verifica si billable_amount es diferente de null y undefined
      return `$ ${numberFormatterWithDecimalAndThousand(billable_amount)}`
    }

    return '$ 0' // Retorna un valor por defecto si billable_amount no existe
  }

  const handleUpdateProductsBillable = async (data) => {
    const dataAux = Array.isArray(data) ? data : [data]
    const productsBillableAux = { ...(productsBillable || {}) }
    setIsBillingLoading(true)
    try {
      dataAux.forEach((elem) => (productsBillableAux[elem.id] = !productsBillableAux[elem.id]))
      setProductsBillable(productsBillableAux)
      const response = Array.isArray(data)
        ? await reservationServices.updateIsBillableProducts(data.map((elem) => elem.hash_), !Object.values(productsBillable).every((elem) => elem) )
        : await reservationServices.updateIsBillableProduct(data.hash_, productsBillableAux?.[data.id])
      if (response) {
        refresh()
        notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
        return
      }
    } catch (error) {
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
      dataAux.forEach((elem) => (productsBillableAux[elem.id] = !productsBillableAux[elem.id]))
      setProductsBillable(productsBillableAux)
    } finally {
      setIsBillingLoading(false)
    }
  }

  const handleClickAllProductsBillable = () => {
    const products = Object.values(productsBillable || {}).every((elem) => elem)
      ? record.items
      : record.items.filter((elem) => !productsBillable[elem.id])

    handleUpdateProductsBillable(products)
  }

  const handleUpdateProductsAutoBill = async (data, checked = false) => {
    const dataAux = Array.isArray(data) ? data : [data]
    const productsAutoBillAux = { ...(productsAutoBill || {}) }
    setAutobillLoading(true)
    try {
      dataAux.forEach((elem) => (productsAutoBillAux[elem.id] = !productsAutoBillAux[elem.id]))
      setProductsAutoBill(productsAutoBillAux)

      const response = Array.isArray(data)
        ? await reservationServices.updateAutoBillProducts(data.map((elem) => elem.hash_), !Object.values(productsAutoBill).every((elem) => elem))
        : await reservationServices.updateAutoBillProduct(data.hash_, checked)
      if (response) {
        notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
        return
      }
    } catch (error) {
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
      dataAux.forEach((elem) => (productsAutoBillAux[elem.id] = !productsAutoBillAux[elem.id]))
      setProductsAutoBill(productsAutoBillAux)
    } finally {
      setAutobillLoading(false)
    }
  }

  const handleClickAllProductsAutoBill = () => {
    const products = Object.values(productsAutoBill || {}).every((elem) => elem)
      ? record.items
      : record.items.filter((elem) => !productsAutoBill[elem.id])

    handleUpdateProductsAutoBill(products)
  }

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loadingCancelItem}>
        <CircularProgress color='inherit' />
      </Backdrop>

      <Grid container spacing={2} columns={24}>
        <Grid item xs={24} xl={13}>
          <WrapperCardId>
            <ReAssignModalSeller
              open={openSellerModal}
              handleClose={() => {
                setOpenSellerModal(false)
              }}
              titleModal={translate('ra.title.re_assign', { entity: translate('ra.field.seller') })}
              optionsText={['firstname', 'surname']}
              avoid={[
                ...modal.avoid,
                'is_superadmin',
                'is_staff',
                'hash_user',
                'hashuser',
                'all_devices',
                'language',
                'is_hidden',
                'is_admin',
                'long_name',
                'short_name',
              ]}
              onSubmitCustom={(data, cardId) => onSubmitReAssignSeller(data, cardId)}
              actionButtonLoading={sellerUpdateLoading}
            />
            <ReAssignModalBase
              open={openBaseModal}
              handleClose={() => setOpenBaseModal(false)}
              titleModal={translate('ra.title.re_assign', { entity: translate('ra.field.base_to_billing') })}
              onSubmitCustom={(baseId, cardId) => onSubmitReAssignBase(baseId, cardId)}
            />

            <ShowCard
              iconHeader={<EventIcon />}
              title={translate('ra.title.general_information')}
              optionHeigth={'general'}
            >
              <LeftSideCard>
                <ShowElement source='number' label={translate('ra.field.number')} />
                <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <ShowElement source='status' label={translate('ra.field.status')} />
                  <HasPermission resource={'reservation'} permission='status'>
                    <Button onClick={()=>setOpenStatusDialog(true)} style={{color:'gray'}} disabled={record.status === 'OPEN'}>
                      <EditIcon fontSize='small' />
                    </Button>
                  </HasPermission>
                </div>
                <ShowElement data={record?.date_in} label={translate('ra.field.date_first_service')} date />
                {hasPermissionFunction('reservation', 'show_base') && (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0px' }}>
                    <span style={{ fontWeight: 600, padding: '0px 5px', whiteSpace: 'nowrap' }}>
                      {translate('ra.field.base_to_billing')}:
                    </span>
                    <ShowElement
                      data={record?.bases_relation?.name}
                      onlyValue
                      blueText
                      actionButton={
                        hasPermissionFunction('reservation', PERMISSION_CHANGE) ? (
                          <EditButton
                            onClick={() => setOpenBaseModal(true)}
                            disabled={loadingBaseEditBlocked || (!hasPermissionFunction('pricing', 'edit_billed') && isBaseEditBlocked)}
                          />
                        ) : undefined
                      }
                    />
                  </div>
                )}
                {record.external_id && (
                  <ShowElement source='external_id' label={translate('ra.field.operation_id')} />
                )}
              </LeftSideCard>
              <RigthSideCard>
                <ShowElement source='passenger' label={translate('ra.field.passenger')} blueText />
                <ShowElement
                  source='user'
                  label={translate('ra.field.seller')}
                  blueText
                  actionButton={
                    hasPermissionFunction('reservation', PERMISSION_CHANGE) ? (
                      <EditButton onClick={() => setOpenSellerModal(true)} />
                    ) : undefined
                  }
                />
                <ShowElement source='creator' label={translate('ra.field.user')} />
                <ShowElement source='create_at' label={translate('ra.field.created_at')} dateFormatCustom={timeZoneFormat} />
              </RigthSideCard>
            </ShowCard>
          </WrapperCardId>
        </Grid>
        <Grid item xs={24} xl={11}>
          <WrapperCardId>
            <ReAssignModal
              open={openClientModal}
              handleClose={() => {
                setOpenClientModal(false)
              }}
              titleModal={translate('ra.title.re_assign', { entity: 'Cliente' })}
              actionButtonLoading={businessUnitUpdateLoading}
              avoid={[...modal.avoid, 'token', 'hash_business_unit', 'country_long_name', 'fiscal_data_name', 'hash_work_unit', 'work_unit_token']}
              onSubmitCustom={(data, cardId) => onSubmitReAssignClient(data, cardId)}
              work_unit_id={record?.work_unit_relation?.id}
            />
            <ShowCard
              iconHeader={<PersonIcon />}
              title={translate('ra.title.client')}
              actionButtonText={translate('ra.title.re_assign', { entity: 'cliente' })}
              actionButtonIcon={<EditIcon />}
              onClickButton={
                hasPermissionFunction('reservation', PERMISSION_CHANGE)
                  ? () => setOpenClientModal(true)
                  : undefined
              }
              optionHeigth={'general'}
            >
              <LeftSideCard>
                <ShowElement source='business_unit_relation.id' label={translate('ra.field.id')} />
                <ShowElement
                  source='business_unit_relation.fantasy_name'
                  label={translate('ra.field.name')}
                />
                <ShowElement source='business_unit_relation.email' label={translate('ra.field.email')} />
                {hasPermissionFunction('work-unit', PERMISSION_CREATE) && (
                  <ShowElement
                    source='work_unit_relation.long_name'
                    label={translate('ra.field.work_unit')}
                  />
                )}
              </LeftSideCard>
              <RigthSideCard>
                <ShowElement
                  source='business_unit_relation.business_type.long_name'
                  label={translate('ra.field.business_type')}
                  blueText
                />
                <ShowElement
                  source='business_unit_relation.fiscal_data_relation.name'
                  label={translate('ra.field.business_name')}
                />
                <ShowElement
                  source='business_unit_relation.user'
                  label={translate('ra.field.managerResponsible')}
                />
                <ShowElement
                  source='business_unit_relation.salesperson'
                  label={translate('ra.field.commercial_responsible')}
                />
              </RigthSideCard>
            </ShowCard>
          </WrapperCardId>
        </Grid>
      </Grid>

      <Grid container spacing={2} columns={24}>
        <Grid item xs={24} xl={24}>
          <ShowCard className='products-card' title={translate('ra.title.products')}>
            <CompleteSideCard>
              <Datagrid
                body={CustomBody}
                isLoading={isFetching && isLoading}
                data={record?.items || []}
                bulkActionButtons={false}
                header={<CustomHeader />}
              >
                <FunctionField
                  label={translate('ra.field.product')}
                  render={(record) => iconAccordingProduct(record.product.ref_table_detail)}
                />
                <TextField label={translate('ra.field.reserve')} source='external_id' sortable={false} />
                <FormattedTextFieldWithStatus
                  label={translate('ra.field.status')}
                  source='status'
                  sortable={false}
                />
                <FormattedTextFieldWithStatus
                  label={translate('ra.field.payment_status')}
                  source='payment_status'
                  sortable={false}
                />
                {hasPermissionFunction('billing', PERMISSION_SHOW) && (
                  <BillingStatus label={translate('ra.field.billing_status')} />
                )}
                {hasPermissionFunction(DUE_DATE_RANGE_PERMISSION_ENTITY, PERMISSION_SHOW) && (
                  <DueDate label={translate('ra.field.due_date')} />
                )}

                <FunctionField
                  label={translate('ra.field.amount')}
                  sortable={false}
                  style={{ fontSize: '15px' }}
                  render={(record) => getBillableAmount(record)}
                />
                {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                  <FunctionField
                    textAlign='right'
                    label={
                      <>
                        {translate('ra.field.is_billable')}

                          <Checkbox
                            sx={{ marginLeft: 1 }}
                            checked={
                              productsBillable ? Object.values(productsBillable).every((elem) => elem) : false
                            }
                            disabled = {(loadingItems || isFetching || isBillingLoading) }
                            onChange={handleClickAllProductsBillable}
                          />
                          {(loadingItems || isFetching || isBillingLoading)  && <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />}
                      </>
                    }
                    render={(record) => (
                      <>
                          <Checkbox
                            checked={productsBillable?.[record.id] ? true : false}
                            onChange={() => handleUpdateProductsBillable(record)}
                            disabled={(loadingItems || isFetching || isBillingLoading)}
                          />
                          {(loadingItems || isFetching || isBillingLoading) && <CircularProgress size={'10px'} />}
                      </>
                    )}
                  />
                )}
                {hasPermissionFunction('item', PERMISSION_AUTO_BILL) && (
                  <FunctionField
                    textAlign='right'
                    label={
                      <>
                        {translate('ra.field.auto_bill')}
                          <Checkbox
                            sx={{ marginLeft: 1 }}
                            checked={
                              productsAutoBill ? Object.values(productsAutoBill).every((elem) => elem) : false
                            }
                            onChange={handleClickAllProductsAutoBill}
                            disabled={(loadingItems || isFetching || autobillLoading) }
                          />
                          {(loadingItems || isFetching || autobillLoading)  && <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />}
                      </>
                    }
                    render={(record) => (
                      <>
                          <Checkbox
                            checked={productsAutoBill?.[record.id] ? true : false}
                            disabled = {(loadingItems || isFetching || autobillLoading)}
                            onChange={() => handleUpdateProductsAutoBill(record,!(productsAutoBill?.[record.id] ? true : false))}
                          />
                          {(loadingItems || isFetching || autobillLoading) && <CircularProgress size={'10px'} />}
                      </>
                    )}
                  />
                )}
              </Datagrid>
            </CompleteSideCard>
          </ShowCard>
          <ConfirmationDialog
            title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
            buttonConfirmText={translate('ra.action.to_confirm')}
            buttonCancel={translate('ra.action.cancel')}
            loadingModalButton={loadingCancelItem}
            setOpen={setOpen}
            setConfirm={setConfirm}
            open={open}
          />
          <ConfirmationDialog
            contentText={translate('ra.message.open_status',{reserva:record.number})}
            buttonConfirmText={translate('ra.action.to_confirm')}
            buttonCancel={translate('ra.action.cancel')}
            loadingModalButton={loadingOpenStatus}
            setOpen={setOpenStatusDialog}
            setConfirm={setConfirmOpenStatus}
            open={openStatusDialog}
          />
        </Grid>
        {/* <Grid item xs={24} xl={11}>
          <ShowCard title={'Comentarios'}></ShowCard>
        </Grid> */}
      </Grid>
    </>
  )
}
